import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27181619"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "moldure",
  "data-top-element": ""
}
const _hoisted_2 = { class: "moldure__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_menu = _resolveComponent("my-menu")!
  const _component_my_header = _resolveComponent("my-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_FooterGTop = _resolveComponent("FooterGTop")!
  const _component_my_footer = _resolveComponent("my-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_my_menu, {
      "is-open": _ctx.isMenuOpen,
      items: _ctx.menuItems,
      "user-already-toggle": _ctx.userAlreadyToggle
    }, null, 8, ["is-open", "items", "user-already-toggle"]),
    _createVNode(_component_my_header, {
      class: "moldure__header",
      onToggleMenu: _ctx.toggleMenu
    }, null, 8, ["onToggleMenu"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ]),
    (_ctx.isGTopTemplate())
      ? (_openBlock(), _createBlock(_component_FooterGTop, { key: 0 }))
      : (_openBlock(), _createBlock(_component_my_footer, { key: 1 }))
  ]))
}